<template>
    <div class="form-page">
        <my-form 
            v-model="form" 
            table 
            :submit-url="`${getGetters('ageUrl')}/DingBiao/ZbJgTzs/xingtai/seal/info.json`"
            @cancle="cancleHandler" >
            <el-form-item 
                label="标段名称" 
                prop="bdcode" 
                :rules="newRule('标段名称', 'required','change')" 
                class="table-full-row">
                <my-select 
                    :data="bdlist" 
                    v-model="form.bdcode" 
                    placeholder="请选择标段名称" 
                    @select="gethxr"
                    :props="{value:'bdcode',label:'bdname'}"
                    2way="bdname"
                    :bdname.sync="form.bdname"
                    style="width:100%;">
                </my-select>
            </el-form-item>
            <el-form-item 
                label="中标人" 
                prop="tbdwcode"  
                class="table-full-row"
                :rules="newRule('中标人', 'required')">
                    <my-select
                        :data="zbhxrlist" 
                        v-model="form.tbdwcode"
                        placeholder="请选择中标人/未中标人"
                        :props="{value:'hxrdwcode',label:'hxrdwname'}" 
                        2way="hxrdwname"
                        :hxrdwname.sync="form.tbdwname"
                        style="width:100%;">
                    </my-select>
                    <my-tag type="danger">注意：选择中标人之前必须先选择标段</my-tag>
            </el-form-item>

            <el-form-item 
                label="附件"  
                class="table-full-row">
                    <my-upload 
                        :file-guid="form.fileguid" 
                        file-type=".pdf"  
                        :file-size="100"
                        @signature="signature">
                    </my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">

                <el-button @click="scope.submitHandler" type="primary" icon="el-icon-circle-check">
                    提交
                </el-button>

                <el-button 
                icon="el-icon-circle-close" 
                @click="scope.cancleHandler">
                    取消
                </el-button>
            </template>
        </my-form>
        <el-dialog
            title="在线签章"
            :visible.sync="CAqzDialogVisible"
            width="1000px">
            <div style="width:900px;height:580px;margin:0 auto">
                <iframe 
                    id="iframeId" 
                    :src="iframeUrl" 
                    frameborder="0" 
                    style="width:900px;height:580px;margin:0 auto">
                </iframe>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button type="primary" @click="sign">签章</el-button>
                <el-button type="warning" @click="saveQz">保存签章</el-button>
                <el-button @click="CAqzDialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import MyUpload from '../components/my-upload' //上传附件
export default {
    mixins: [FORM_PAGE_MIXIN],
    components:{ MyUpload },
    data() {
        return{
            form:{
                fileguid:''
            },
            bdlist:[],
            zbhxrlist:[],
            fileList:[],
            // 弹窗
            CAqzDialogVisible:false,
            iframeUrl:'',
        }
    },
    computed: {

    },
    watch: {
        
    },
    methods: {
        // 调用ca签章
        signature(val){
            this.CAqzDialogVisible = true;
            this.iframeUrl = '/static/bidding/views/signature/index.html?fileurl='+val.realip+val.filesavepath.replace(/\\/g, "/")+'&rowguid='+val.rowguid;
            
        },
        //获取候选人
        gethxr:function(data, status){
            var that = this
            that.$post(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/get_hxr_rest.json`,{
                bdcode:data.bdcode,
                status:'2'
            }, (data, res) => {
                that.zbhxrlist=data.list;
            });
        },
        // 调用object 工具栏签章按钮
        sign(){
            var iframe = window.document.getElementById("iframeId"); 
            iframe.contentWindow.TestClickInsertSealButton();
        },
        // 保存签章文件
        saveQz(){
            var iframe = window.document.getElementById("iframeId"); 
            iframe.contentWindow.saveQz();
        },
        closeDialogVisible(){
            ShowMsg('保存签章成功', 'success');
            this.form.shbj = '1';
            this.CAqzDialogVisible = false;
        }
    },
    created() {
        var that = this;
        that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/addinit.json`,{
            zbprocode:this.$route.query.zbprocode
        }, (data, res) => {
            that.bdlist=data.bdlist;
        });
    },
    mounted() {
        var that = this;
        // 保存中间间  用于iframe调用
        middleware('closeDialogVisible',that.closeDialogVisible.bind(this));

        // 判断是否是编辑
        if(that.getQuery('guid')){
            // 编辑 获取详情
            that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/seal/detail.json`,{
                guid:that.getQuery('guid')
            },(data, res) => {
                that.gethxr(data)
                that.form = data;
            })
        }else{
            // 获取fileguid
            that.$get(`/standalonfile/operate/getfileguid.json`,(data, res) => {
                that.form.fileguid = data;
            })
        }
        

    }
}
</script>

<style scoped lang="scss">

</style>
